<template lang="pug">
.campaign(v-if="isVisible")
  .l-container.is-lg
    .campaign-box
      .campaign-box-thumb
        img(alt="10月限定キャッシュバックキャンペーン" :src="require('~/assets/images/school/common/campaign.png')" width="530" height="298.312")
      .campaign-box-txt(:class="{ 'is-active': isCampaignShow }")
        .campaign-box-txt-catch
          .campaign-box-txt-catch-ttl
            span.pc 《
            | 選べる2つの特典！
            br.sp
            | 入学金割引 or まとめ払い割引率アップ
            span.pc 》
        ul
          li
            | 2026年10月1日〜10月31日 15:00までにお申し込みいただいた方が対象です。
          li
            | オンライン相談会への参加、または資料請求が必要となります。
          li
            | 「入学金10%割引」と「まとめ払い割引15%」の併用はできません。
          li
            | 他のキャンペーンとの併用はできません。
          li
            | キャッシュバックは入校後の対応となりますので、あらかじめご了承ください。
          li
            | エントリープランは本キャンペーンの対象外です。
      .campaign-more.sp
        .campaign-more-btn(@click="showMoreCampaign")
          | MORE
</template>

<script>
import dayjs from '~/libs/dayjs'

export default {
  // 設定方法：SchoolCampaign(start="2026-06-01T00:00:00" end="2026-06-30T15:00:00")
  props: {
    start: {
      type: String,
      default: ''
    },
    end: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isCampaignShow: false,
      isVisible: false
    }
  },
  mounted() {
    const now = dayjs()
    if (this.start && now.isBefore(dayjs(this.start))) {
      return
    }
    if (this.end && now.isAfter(dayjs(this.end))) {
      return
    }
    this.isVisible = true
  },
  methods: {
    showMoreCampaign() {
      this.isCampaignShow = !this.isCampaignShow
    }
  }
}
</script>
<style lang="scss" scoped>
.campaign {
  padding: 50px 0;
  background-color: #fff;
  color: #000;
  @include media(sp) {
    padding: 15px;
  }
  &-box {
    border: 1px solid #ccc;
    & + .campaign-box {
      margin-top: 40px;
      @include media(sp) {
        margin-top: 20px;
      }
    }
    @include media(pc) {
      display: flex;
      justify-content: center;
    }
    &-thumb {
      @include media(pc) {
        width: 530px;
      }
      @include media(sp) {
        margin-bottom: 5px;
      }
      img {
        width: 100%;
        vertical-align: bottom;
      }
    }
    &-txt {
      line-height: 1.5;
      @include media(sp) {
        position: relative;
        overflow: hidden;
        margin-bottom: 10px;
        max-height: 150px;
      }
      @include media(pc) {
        flex: 1;
        height: 278px;
        padding: 30px 40px 20px 36px;
        @include scrollbar_y($width: 8px, $track_bg: #ccc, $thumb_bg: #000);
      }
      &:after {
        @include media(sp) {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          pointer-events: none;
          width: 100%;
          height: 50px;
          background: linear-gradient(180deg, transparent, #fff);
        }
      }
      &.is-active {
        @include media(sp) {
          max-height: unset;
        }
        & + .campaign-more {
          @include media(sp) {
            display: none;
          }
        }
        &:after {
          @include media(sp) {
            display: none;
          }
        }
      }
      &-catch {
        padding: 10px;
        margin-bottom: 20px;
        border-bottom: 1px solid #000;
        &-ttl {
          font-size: 19px;
          font-weight: bold;
          margin-bottom: 5px;
          @include media(sp) {
            font-size: 15px;
          }
        }
        p {
          margin-bottom: 10px;
          span {
            font-weight: bold;
          }
        }
      }
      ul {
        @include media(sp) {
          padding: 5px 10px 10px 5px;
        }
        li {
          font-size: 13px;
          list-style: none;
          padding-left: 2em;
          text-indent: -1.4em;
          @include media(sp) {
            font-size: 12px;
          }
          &::before {
            content: '※';
            margin-right: 5px;
          }
        }
        li + li {
          margin-top: 5px;
        }
      }
    }
    .campaign-more {
      //- .s_index-about-roundより上に配置する（ボタンが押せなくなるのを避けるため）
      @include media(sp) {
        position: relative;
        z-index: 2;
        padding-bottom: 10px;
      }
      &:hover {
        @include media(sp) {
          opacity: 0.7;
        }
      }
      &-btn {
        @include media(sp) {
          transition: all 0.2s;
          cursor: pointer;
          position: relative;
          display: table;
          margin: 0 auto;
          padding: 20px 60px 20px 35px;
          text-decoration: none;
          color: #000;
          font-size: 16px;
          font-style: italic;
        }
        &:after {
          @include media(sp) {
            position: absolute;
            top: calc(50% - 15px);
            right: 15px;
            content: '';
            background: url(~/assets/images/school/common/arrow-bottom.png)
              center top 10px / 15px auto no-repeat;
            width: 30px;
            height: 30px;
            border-radius: 30px;
            border: solid 1px #000;
          }
        }
      }
    }
  }
}
</style>
